export default __webpack_public_path__ + "static/media/CapaAddtoGroupBlue.49343049.svg";